import React, { useState } from "react";
import RelatedLinks from "../RelatedLinks";
import { SecondAds, FirstAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Random Number Generator";
const DESCRIPTION =
  "A random number generator helps you generate random numbers within a specific range. You can set the minimum and maximum values of the range, as well as the number of random numbers you want to generate.";
const KEYWORDS =
  "random number generator, generate random numbers, random number tool";
const OG_URL =
  "https://do-calculate.com/calculator/en/random-number-generator/";
function RandomNumberGenerator() {
  const [min, setMin] = useState("0");
  const [max, setMax] = useState("100");
  const [count, setCount] = useState("1");
  const [results, setResults] = useState([]);
  const [error, setError] = useState(null);
  const handleMinChange = (event) => {
    setMin(event.target.value);
  };
  const handleMaxChange = (event) => {
    setMax(event.target.value);
  };
  const handleCountChange = (event) => {
    setCount(event.target.value);
  };
  const generateRandomNumbers = () => {
    const minNum = parseInt(min);
    const maxNum = parseInt(max);
    const countNum = parseInt(count);
    if (
      isNaN(minNum) ||
      isNaN(maxNum) ||
      isNaN(countNum) ||
      minNum >= maxNum ||
      countNum <= 0
    ) {
      setError("Enter valid inputs");
      setResults([]);
      return;
    }
    const randomNumbers = Array.from(
      { length: countNum },
      () => Math.floor(Math.random() * (maxNum - minNum + 1)) + minNum
    );
    setResults(randomNumbers);
    setError(null);
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "39px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  A random number generator is a tool that helps you generate
                  random numbers within a specific range. It allows you to set
                  the minimum and maximum values of the range, as well as the
                  number of random numbers you want to generate. This tool is
                  commonly used in various fields such as statistics,
                  cryptography, and simulation. A random number generator is
                  essential in ensuring fairness in games of chance, creating
                  secure encryption keys, conducting scientific research, and
                  testing software applications. By using a random number
                  generator, you can eliminate bias and predictability, ensuring
                  that each number generated is truly random and independent of
                  previous numbers. This tool is valuable for creating unique
                  codes, passwords, and random samples for statistical analysis.
                  Overall, a random number generator is a versatile tool that
                  provides randomness and unpredictability in various
                  applications.
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-12 col-md-5 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  Random Number Generator{" "}
                </div>
                <hr />
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="min" className="form-label ms-2">
                      Minimum Value
                    </label>
                  </b>
                  <input
                    type="number"
                    id="min"
                    value={min}
                    onChange={handleMinChange}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                    placeholder="0"
                  />
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="max" className="form-label ms-2">
                      Maximum Value{" "}
                    </label>
                  </b>
                  <input
                    type="number"
                    id="max"
                    value={max}
                    onChange={handleMaxChange}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                    placeholder="100"
                  />
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="count" className="form-label ms-2">
                      Number of outputs
                    </label>
                  </b>
                  <input
                    type="number"
                    id="count"
                    value={count}
                    onChange={handleCountChange}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                    placeholder="1"
                  />
                </div>
                <br />
                <hr />
                <div>
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px" }}
                    onClick={generateRandomNumbers}
                  >
                    Generate
                  </button>
                </div>
              </div>
              <div className="col-12 col-md-7">
                <div>
                  {error && (
                    <div className="alert alert-warning">
                      <b>
                        <u>An error occured:</u>
                      </b>{" "}
                      {error}
                    </div>
                  )}
                  {results.length > 0 && (
                    <div>
                      <h4>Results:</h4>
                      <hr />
                      <div
                        style={{
                          backgroundColor: "#D1E7DD",
                          borderColor: "#c3e6cb",
                          color: "#155724",
                          padding: "15px",
                          marginBottom: "20px",
                          borderRadius: "4px",
                        }}
                      >
                        <ul>
                          {results.map((num, index) => (
                            <li key={index}>{num}</li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />        </div>
      </div>
      <hr />
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                How to use the random number generator?{" "}
              </div>
              <div className="info-section-body">
                <p>
                  To use the random number generator, enter the minimum and
                  maximum values of the range, then enter the number of numbers
                  you want to get. Click the "Generate" button to get the
                  results.
                </p>
              </div>
            </div>
          </div>
          <br />
          <u>
            {" "}
            <h2>Frequently Asked Questions</h2>
          </u>
          <br />
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  What is a random number generator?
                </h3>
              </div>
              <div className="info-section-body">
                <p>
                  A random number generator is a tool that helps you generate
                  random numbers within a specific range. You can set the
                  minimum and maximum values of the range, as well as the number
                  of numbers you want to get.
                </p>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default RandomNumberGenerator;
